import { CanActivateFn } from '@angular/router';

export const massiveActionsGuard: CanActivateFn = () => {
    let userProfile = JSON.parse(sessionStorage.getItem('user'));
    if (userProfile && userProfile.security && (userProfile.security.massiveTabVisible || userProfile.security.massDeviceTabVisible))
        return true;
    else return false;
};
